import React from "react";
import { CheckCircle2, XCircle, Image as ImageIcon } from "lucide-react";
import { AvatarPicker } from "./AvatarPicker";
import { Toggle } from "./IdentityTab";
import { PROV } from "./agentUtil";

const Check = ({ ok, children }) => <li className={`flex items-center gap-1.5 ${ok ? "text-emerald-700" : "text-slate-400"}`}>{ok ? <CheckCircle2 size={13} /> : <XCircle size={13} />}{children}</li>;

function ProviderCard({ p, a, set, rt, readOnly }) {
  const active = rt?.active_provider === p;
  const info = rt?.providers?.[p] || {};
  const av = a.avatar?.[p] || {};
  const setAv = (patch) => set((x) => ({ avatar: { ...(x.avatar || {}), [p]: { ...((x.avatar || {})[p] || {}), ...patch } } }));
  const balanceOk = p !== "runway" || !info.low;
  return (
    <div className={`aivora-card p-5 ${active ? "ring-2 ring-brand" : ""}`} data-testid={`avatar-card-${p}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-bold text-slate-900">{PROV[p]}</p>
        {active ? <span className="rounded-full bg-brand px-2 py-0.5 text-[10px] font-bold text-white" data-testid={`avatar-active-${p}`}>Dipakai sekarang</span> : <span className="text-[11px] text-slate-400">Persiapan pindah provider</span>}
      </div>
      <div className="mt-4 flex items-center gap-3">
        <div className="relative h-16 w-16 shrink-0 overflow-hidden rounded-xl bg-slate-100">
          <ImageIcon size={18} className="absolute inset-0 m-auto text-slate-300" />
          {av.avatar_preview && <img src={av.avatar_preview} alt="" className="absolute inset-0 h-full w-full object-cover" onError={(e) => { e.currentTarget.style.display = "none"; }} />}
        </div>
        <div className="min-w-0 flex-1">
          <input className="input-ui text-sm" disabled={readOnly} maxLength={120} placeholder="Nama avatar" value={av.avatar_name || ""} onChange={(e) => setAv({ avatar_name: e.target.value })} data-testid={`avatar-name-${p}`} />
          <p className="mt-1 truncate font-mono text-[10px] text-slate-400" data-testid={`avatar-id-${p}`}>{av.avatar_id || "Belum ada avatar"}</p>
        </div>
        {av.avatar_id && !readOnly && <button type="button" onClick={() => setAv({ avatar_id: "", avatar_name: "", avatar_preview: "" })} className="text-[11px] font-semibold text-rose-500 hover:underline" data-testid={`avatar-clear-${p}`}>Hapus</button>}
      </div>
      {p === "runway" && <p className="mt-3 text-[11px] text-slate-500">Batas sesi Runway: maks {info.max_session_minutes ?? 5} menit per sesi.</p>}
      {p === "liveavatar" && <div className="mt-3"><Toggle on={!!av.sandbox} disabled={readOnly} onChange={(v) => setAv({ sandbox: v })} testid="avatar-sandbox" note={`Sesi maks ${info.sandbox_max_seconds ?? 60} detik, gratis untuk uji. Matikan untuk produksi.`}>Sandbox</Toggle></div>}
      <ul className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-[11px] font-semibold" data-testid={`avatar-checklist-${p}`}>
        <Check ok={!!info.configured}>Kunci API</Check><Check ok={!!av.avatar_id}>Avatar</Check>{p === "runway" && <Check ok={balanceOk}>Saldo{info.balance_known ? ` ${info.balance}` : ""}</Check>}
      </ul>
      {!readOnly && <div className="mt-4 border-t border-slate-100 pt-4"><AvatarPicker provider={p} value={av.avatar_id} readOnly={readOnly} onPick={(v) => setAv({ avatar_id: v.id, avatar_name: v.name || "", avatar_preview: v.preview || "" })} /></div>}
    </div>
  );
}

export function AvatarTab(props) {
  const { a, set, readOnly, rt } = props;
  return (
    <div className="space-y-5" data-testid="agent-avatar">
      <div className="aivora-card flex flex-wrap items-center justify-between gap-3 p-5">
        <p className="text-sm text-slate-600">Provider aktif: <b className="text-slate-900" data-testid="agent-active-provider">{PROV[rt?.active_provider] || "—"}</b> <span className="text-xs text-slate-400">(ubah di Model AI › Realtime Avatar)</span></p>
        <Toggle on={!!a.video_enabled} disabled={readOnly} onChange={(v) => set({ video_enabled: v })} testid="agent-video-enabled">Video interaktif</Toggle>
      </div>
      <div className="grid gap-5 xl:grid-cols-2">{["runway", "liveavatar"].map((p) => <ProviderCard key={p} p={p} {...props} />)}</div>
    </div>
  );
}
